import { FC, useEffect, useLayoutEffect } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import Helmet from '@/components/meta/Helmet';
import GlossaryListTemplate from '@/components/templates/Glossary/List';
import { SYLLABARY } from '@/config/constants';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';
import { client } from '@/lib/microcms';
import { assertIsDefined } from '@/utility/utils';

const GlossaryListPage: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  const { initial } = useParams<{
    initial: string;
  }>();
  assertIsDefined(initial);

  useEffect(() => {
    setBreadcrumbs([
      {
        name: '競輪用語集',
        to: '/glossary',
      },
      {
        name: initial,
        to: '',
      },
    ]);
  }, []);

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  const initials = SYLLABARY.flat().filter(line => line[0] === initial)[0];

  const { data: terms, isLoading } = useQuery(
    ['glossary', initials],
    async () =>
      client.getContents('glossary', {
        fields: 'termName,hiragana',
        filters: initials.map(w => `hiragana[begins_with]${w}`).join('[or]'),
        limit: 100,
      }),
  );

  return (
    <>
      <Helmet
        meta={{
          title: `競輪用語集 - ${initial}行`,
          description: '競輪用語集あ行のページです。%s',
        }}
      />
      <GlossaryListTemplate
        terms={terms || []}
        initial={initial}
        loading={isLoading}
      />
    </>
  );
};

export default GlossaryListPage;
